export const standardFonts = [
  'Arial', 'Roboto', 'Impact', 'Times New Roman', 'Courier New',
  'Verdana', 'Georgia', 'Garamond', 'monospace',
];
export const standardFontSize = [
  8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72,

];